<template>
   <common-form
      form-title="Land Cover Information"
      :back-route="this.backRoute"
      :errors="errors.non_field_errors"
      @submit="save"
      @save-and-continue="saveAndContinue"
      >
      <atom-button label="Auto-calculate fields" @click="updateDefaultLandcoverInfo"/>
      <input-field v-model="form.forest_sqkm" type="number" label="Forest (Sq.Km.)" :errors="errors.forest_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.shrubland_sqkm" type="number" label="Shrubland (Sq.Km.)" :errors="errors.shrubland_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.grassland_sqkm" type="number" label="Grassland (Sq.Km.)" :errors="errors.grassland_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.agriculture_sqkm" type="number" label="Agriculture (Sq.Km.)" :errors="errors.agriculture_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.barren_sqkm" type="number" label="Barren land (Sq.Km.)" :errors="errors.barren_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.water_body_sqkm" type="number" label="Water body (Sq.Km.)" :errors="errors.water_body_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.builtup_area_sqkm" type="number" label="Built-up area (Sq.Km.)" :errors="errors.builtup_area_sqkm" required :extra-attributes="extraAttributes"/>
      <input-field v-model="form.snow_glacier_sqkm" type="number" label="Snow/glacier (Sq.Km.)" :errors="errors.snow_glacier_sqkm" required :extra-attributes="extraAttributes"/>
   </common-form>
</template>

<script>
import AtomButton from '@/components/atoms/Login/Button';
import CommonForm from '@/components/organisms/Home/Plan/Form'
import InputField from '@/components/molecules/Login/InputField';
import FormMixin from '@/mixins/planform';
import { fetchWithAuthToken } from '@/axios';

export default {
   name: 'land-cover-form',
   components: {
      InputField,
      CommonForm,
      AtomButton,
   },
   data()
   {
      const form = {
         forest_sqkm: null,
         shrubland_sqkm: null,
         grassland_sqkm: null,
         agriculture_sqkm: null,
         barren_sqkm: null,
         water_body_sqkm: null,
         builtup_area_sqkm: null,
         snow_glacier_sqkm: null,
      };

      return {
         form,
         errors: this.getDefaultErrors(form),
         backRoute: {name: 'edit-physical-info',params: {id: this.getPlanId()}},
         nextRoute: {name: 'edit-road-access-info',params: {id: this.getPlanId()}},
         extraAttributes: {step: 0.001},
      };
   },
   mixins: [FormMixin],
   computed: {
      url()
      {
         return `api/plan/${this.getPlanId()}/land-cover`;
      },
      notificationTitle()
      {
         return 'Land Cover Information';
      },
      successMessage()
      {
         return 'Successfuly edited land cover information';
      },
      errorMessage()
      {
         return "Editing land cover information was unsuccessful";
      },
   },
   methods: {
      updateDefaultLandcoverInfo() {
         fetchWithAuthToken(`api/plan/${this.getPlanId()}/default-landcover-info`)
            .then(({data}) => this.form=data)
      }
   }
}
</script>
